import React, { useRef, useState,useEffect } from "react";
import {
    I2cRadioGroup, I2cRadio,
    I2cRadioButton, I2cInput, I2cCheckboxGroup,
    I2cListItem, I2cCheckbox, I2cTab, I2cTabGroup, I2cTabPanel,
    I2cFileUpload, I2cButton, I2cIcon, I2cTooltip, I2cAlert
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import { useFieldArray } from "react-hook-form";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import ConsumerEnrollmentAndShippmentMethod from "./ConsumerEnrollementAndShippmentMethods";
import FundingSourcePrepaid from "./FundingSourcePrepaid";
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"
import BusinessDataTables from "./BusinessDataTables";
import CorporateDataTables from "./CorporateDataTables";
import ShippingMethod from "./ShippingMethod";
import { useMutation } from "react-query";
import FilesUploadService from "../../../Services/FilesUploadService";

import {
    heading_enrollment_Url_Platform, heading_enrollment_url, card_enrollment_card_account_type_data,
    consumer_credit_card_type_data, card_enrollment_agreement_type_for_common_toggle_data, card_enrollment_agreement_type_data
} from './stringUtils';
const ManageInsideI2cPlatform = ({ type, control, handleValueChanges, methods, errors, appSelectionForProgram, isFormDataUpdated, fileJson,setFormValidStates,state }) => {
    const checkboxRef = useRef(null);
 
    const handleCheckboxChange = (event, fieldName) => {
        const SelectedNetworkValue = event;
        let updatedSelectedNetworks = [
            ...(methods.getValues(fieldName) ?? []),
        ];
        if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
            updatedSelectedNetworks = updatedSelectedNetworks.filter(
                (card) => card !== SelectedNetworkValue,
            );
        } else {
            updatedSelectedNetworks.push(SelectedNetworkValue);
        }
        methods.setValue(fieldName, updatedSelectedNetworks);
        methods.trigger();
        handleValueChanges();
    };
    const { fields: fieldArray, append } = useFieldArray({
        control,
        name: "card_enrollment_card_product_groups",
    });
    const handleAddAnother = () => {
        append({
            image_file: "",
            count: "",
            title: "",
            description: "",

        });
    };
    const fileRefs = useRef({});
    // Dynamically create and access refs based on field names
     const getFileRef = (fieldName) => {
       if (!fileRefs.current[fieldName]) {
         fileRefs.current[fieldName] = React.createRef();
       }
       return fileRefs.current[fieldName];
     };
   
     useEffect(() => {
       customElements.whenDefined('i2c-file-upload').then(() => {
         Object.keys(fileRefs.current).forEach((fieldName) => {
           const fileRef = fileRefs.current[fieldName];
           if (fileRef.current !== null) {
             const myDropzone = fileRef.current.getDropZone();
             const token = localStorage.getItem("token");
             myDropzone.options.url = process.env.REACT_APP_API_BASE_URL + "api/file/upload/pdf";
             myDropzone.options.headers = {
               'X-Requested-With': null,
               'Access-Control-Allow-Headers': null,
               'Authorization': 'Bearer ' + token,
             };
           }
         });
       });
     }, []);
     // for PDF, svg, ai files
     const handleFileUpload = async (file, fieldName) => {
       const formData = new FormData();
       formData.append("file", file);
       try {
         await fileUpload.mutate({ formData, fieldName });
       } catch (error) {
         console.log(error);
       } finally {
         methods.trigger();
       }
     };
   
     const fileUpload = useMutation({
       mutationFn: async ({ formData, fieldName }) => {
        //  setFormValidStates(state,false);
         return await FilesUploadService.uploadFile(formData);
       },
       onSuccess: (data, { fieldName }) => {
         if (fieldName === "card_enrollment_agreement_customized_content_file") {
           const currentFiles = methods.getValues(fieldName) || [];
           methods.setValue(fieldName, [...currentFiles, data?.data?.url]);
         }
         else {
           methods.setValue(fieldName, data?.data?.url);
         }
   
         methods.trigger();
         handleValueChanges();
       },
       onError: (e) => {
         console.log("API error", e);
       },
     });

    return (
        <>
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <span className="productIconFlex">
                            <span slot="label" className="organize-tooltip">
                                i2c Platform Selection
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                </div>
                <div i2c-grid="12">
                    <div className="custom-label-light mb-1-5">
                        Please select the platform(s) where the enrollment link will be added.
                    </div>
                    <Controller
                        name="card_enrollment_url_platform"
                        control={control}
                        render={({ field }) => (
                            <I2cCheckboxGroup name="card_enrollment_url_platform" ref={checkboxRef}>
                                <div i2c-grid="grid gap-sm">
                                    {heading_enrollment_Url_Platform.map((card, index) => (
                                        <div key={index} i2c-grid="12 6@md">
                                            <I2cListItem
                                                variant="receipt"
                                                label={card.label}
                                                sublabel=""
                                                value=""
                                                type="checkbox"
                                                checked={methods
                                                    .watch("card_enrollment_url_platform")
                                                    .includes(card.value)}
                                                onI2cCheckboxClicked={(e) =>
                                                    handleCheckboxChange(card.value, "card_enrollment_url_platform")
                                                }
                                            >
                                                <I2cCheckbox
                                                    slot="prefix"
                                                    value={card.value}
                                                    label=""
                                                    ignoreTab
                                                    filled
                                                    checked={methods
                                                        .watch("card_enrollment_url_platform")
                                                        .includes(card.value)}
                                                    className="customCheckbox"
                                                ></I2cCheckbox>
                                            </I2cListItem>
                                        </div>
                                    ))}
                                </div>
                            </I2cCheckboxGroup>
                        )}
                    />
                </div>
            </div>
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <span className="productIconFlex">
                            <span slot="label" className="organize-tooltip">
                                Card Enrollment URL
                                <I2cTooltip
                                    content="Please note that i2c standard nomenclature is: https://brandname-ccart.mycardplace.com/cholder/"
                                    placement="right-start"
                                >
                                    <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
                                </I2cTooltip>
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                </div>
                <div i2c-grid="12">
                    <div className="single-field-wrapper">
                        <Controller
                            name="card_enrollment_card_enrollment_url_type"
                            control={control}
                            render={({ field }) => (
                                <I2cRadioGroup
                                    label="Please select the type of URL you want to use for enrollment screens."
                                    {...field}
                                    name="card_enrollment_card_enrollment_url_type"
                                    onI2cChange={(e) => {
                                        field.onChange(e);
                                        if(e.target.value !== "Custom URL"){
                                            methods.setValue("card_enrollment_card_enrollment_url","")
                                        }
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                >
                                    {heading_enrollment_url.map((eT, index) => (
                                        <I2cRadioButton
                                            key={index}
                                            checked={
                                                methods.watch("card_enrollment_card_enrollment_url_type") === eT.value
                                            }
                                            value={eT.value}
                                        >
                                            {eT.label}
                                        </I2cRadioButton>
                                    ))}
                                </I2cRadioGroup>
                            )}
                        />
                        <ErrorMessage
                            show={
                                errors.card_enrollment_card_enrollment_url_type &&
                                    methods.formState.touchedFields.card_enrollment_card_enrollment_url_type
                                    ? true
                                    : false
                            }
                            message={errors.card_enrollment_card_enrollment_url_type?.message ?? "Invalid input"}
                        />
                    </div>
                </div>
                {
                    methods.watch("card_enrollment_card_enrollment_url_type") === "Custom URL" && (
                        <div i2c-grid="12 6@md">
                            <div className="single-field-wrapper">
                                <Controller
                                    name="card_enrollment_card_enrollment_url"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cInput
                                            {...field}
                                            className="single-input-field"
                                            placeholder="www.i2cinc.com/enrollment"
                                            onI2cInput={(e) => {
                                                const value = e.target.value;
                                                field.onChange(value);
                                                handleValueChanges();
                                            }}
                                            size="large"
                                            name={"card_enrollment_card_enrollment_url"}
                                            prefix_label="http://"
                                        >
                                            <span slot="label" className="organize-tooltip">
                                                <span className="custom-label">
                                                    {" "}
                                                    Custom URL<sup>•</sup>
                                                </span>
                                            </span>
                                        </I2cInput>
                                    )}
                                />
                            </div>
                        </div>
                    )
                }
            </div>
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <span className="productIconFlex">
                            <span slot="label" className="organize-tooltip">
                                Card Account Type
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                </div>
                <div i2c-grid="12">
                    <div className="custom-label-light mb-1-5">
                        Please specify if the card account will be virtual or plastic or both.
                    </div>
                    <div className="single-field-wrapper">
                        <Controller
                            name="card_enrollment_card_account_type"
                            control={control}
                            render={({ field }) => (
                                <I2cRadioGroup
                                    onI2cChange={(e) => {
                                        methods.setValue("card_enrollment_card_account_type", e.target.value);
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                >
                                    <div i2c-grid="grid gap-sm">
                                        {card_enrollment_card_account_type_data.map((cpi, index) => (
                                            <I2cListItem
                                                key={index}
                                                i2c-grid="4@md"
                                                variant="receipt"
                                                label={cpi.label}
                                                sublabel=""
                                                value=""
                                                checked={methods.watch("card_enrollment_card_account_type") === cpi.value}
                                                type="checkbox"
                                            >
                                                <I2cRadio
                                                    slot="prefix"
                                                    name="card_enrollment_card_account_type"
                                                    value={cpi.value}
                                                    filled
                                                    label=""
                                                    checked={
                                                        methods.watch("card_enrollment_card_account_type") === cpi.value
                                                    }
                                                />
                                            </I2cListItem>
                                        ))}
                                    </div>
                                </I2cRadioGroup>
                            )}
                        />
                    </div>
                </div>
            </div>
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span slot="label" className="organize-tooltip">
                                    Card Products
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a"
                                />
                            </span>
                        </div>
                    </div>
                </div>
                {
                    fieldArray.map((field, index) => (
                        <>
                            <div i2c-grid="12">
                                <div className="custom-label mb-1-5">
                                    Please also provide a JPG or PNG image of the card products.
                                </div>
                                <Controller
                                    name={`card_enrollment_card_product_groups[${index}].images_file`}
                                    control={control}
                                    render={({ field }) => (
                                        <I2cFileUpload
                                            ref={getFileRef(`card_enrollment_card_product_groups[${index}].images_file`)}
                                            autoProcessQueue={false}
                                            no-mobile-controls 
                                            max-files={1}
                                            className="customFileUpload"
                                            setAcceptedFiles=".png, .jpg,.ai,.pdf,.svg"
                                            icon="linear-document-upload"
                                            label="Click to upload"
                                            caption="or drag and drop"
                                            name={`card_enrollment_card_product_groups[${index}].images_file`}
                                            message="Format must be SVG, AI, PDF or ESP Format."
                                            onI2cFileRemoved={(e) => {
                                                const fieldName = `card_enrollment_card_product_groups[${index}].images_file`;
                                                if (
                                                  fileJson?.[fieldName]?.length
                                                )
                                                  methods.setValue(
                                                    fieldName,
                                                    fileJson?.fieldName,
                                                  );
                                                else methods.setValue(fieldName, "");
                                                methods.trigger();
                                                handleValueChanges();
                                              }}
                                              onI2cAddedFile={(e) => {
                                                const fieldName = `card_enrollment_card_product_groups[${index}].images_file`;
                                                const fileRef = getFileRef(fieldName);
                                                handleFileUpload(
                                                  fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                                  fieldName
                                                );
                                              }}
                          
                                        />
                                    )}
                                />
                            </div>
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <Controller

                                        name={`card_enrollment_card_product_groups[${index}].count`}
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                placeholder="Please specify"
                                                required
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={`card_enrollment_card_product_groups[${index}].count`}
                                            >
                                                <span slot="label" className="organize-tooltip">
                                                    <span className="custom-label">
                                                        {" "}
                                                        Please select how many Card Products you want to offer for enrollment.
                                                    </span>
                                                </span>
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12">
                                <div i2c-grid="grid gap-sm">
                                    <div i2c-grid="12" className="custom-label">
                                        What are the card product groups that should be displayed to cardholders during enrollment?
                                    </div>
                                    <div i2c-grid="12 6@md">
                                        <div className="single-field-wrapper">
                                            <Controller
                                                key={field.id}
                                                name={`card_enrollment_card_product_groups[${index}].title`}
                                                control={control}
                                                render={({ field }) => (
                                                    <I2cInput
                                                        {...field}
                                                        className="single-input-field"
                                                        placeholder="Enter title"
                                                        required
                                                        onI2cInput={(e) => {
                                                            const value = e.target.value;
                                                            field.onChange(value);
                                                            handleValueChanges();
                                                        }}
                                                        size="large"
                                                        name={`card_enrollment_card_product_groups[${index}].title`}
                                                    >
                                                        <span slot="label" className="organize-tooltip">
                                                            <span className="custom-label">
                                                                {" "}
                                                                Title
                                                            </span>
                                                        </span>
                                                    </I2cInput>
                                                )}
                                            />
                                        </div>
                                    </div>
                                    <div i2c-grid="12 6@md">
                                        <div className="single-field-wrapper">
                                            <Controller
                                                key={field.id}
                                                name={`card_enrollment_card_product_groups[${index}].description`}
                                                control={control}
                                                render={({ field }) => (
                                                    <I2cInput
                                                        {...field}
                                                        className="single-input-field"
                                                        placeholder="Enter a description..."
                                                        required
                                                        onI2cInput={(e) => {
                                                            const value = e.target.value;
                                                            field.onChange(value);
                                                            handleValueChanges();
                                                        }}
                                                        size="large"
                                                        name={`card_enrollment_card_product_groups[${index}].description`}
                                                    >
                                                        <span slot="label" className="organize-tooltip">
                                                            <span className="custom-label">
                                                                {" "}
                                                                Description
                                                            </span>
                                                        </span>
                                                    </I2cInput>
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ))
                }

                <div i2c-grid="12 6@md">
                    <div className="single-field-wrapper">
                        <I2cButton variant="link color"
                            onClick={handleAddAnother}>
                            <I2cIcon slot="prefix" name="linear-add"></I2cIcon> Add Another
                        </I2cButton>
                    </div>
                </div>
            </div>
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        Card Product Category(s)
                    </div>
                </div>
                <I2cTabGroup i2c-grid="12" className="card-enrollment-tabs" activation="manual">
                    <I2cTab slot="nav" panel="Consumer">
                        Consumer
                    </I2cTab>
                    <I2cTab slot="nav" panel="Business">
                        Business
                    </I2cTab>
                    <I2cTab slot="nav" panel="Corporate">
                        Corporate
                    </I2cTab>
                    <I2cTabPanel name="Consumer">
                        <div className="section-space">
                            <Controller
                                name="card_enrollment_category_consumer_link_platform_to_i2c"
                                control={control}
                                render={({ field }) => (
                                    <I2cRadioGroup
                                        label="Do you want to opt for this product category?"
                                        {...field}
                                        name="card_enrollment_category_consumer_link_platform_to_i2c"
                                        onI2cChange={(e) => {
                                            field.onChange(e);
                                            if(e.target.value === "No"){
                                                methods.setValue("card_enrollment_category_consumer_title_for_enrollment_screen","")
                                                methods.setValue("card_enrollment_category_consumer_description_for_enrollment_screen","")
                                            }
                                            methods.trigger();
                                            handleValueChanges();
                                        }}
                                    >
                                        {["Yes", "No"].map((cECPTD, index) => (
                                            <I2cRadioButton
                                                key={index}
                                                checked={
                                                    methods.watch("card_enrollment_category_consumer_link_platform_to_i2c") === cECPTD
                                                }
                                                value={cECPTD}
                                            >
                                                {cECPTD}
                                            </I2cRadioButton>
                                        ))}
                                    </I2cRadioGroup>
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.card_enrollment_category_consumer_link_platform_to_i2c &&
                                        methods.formState.touchedFields.card_enrollment_category_consumer_link_platform_to_i2ce
                                        ? true
                                        : false
                                }
                                message={errors.card_enrollment_category_consumer_link_platform_to_i2c?.message ?? "Invalid input"}
                            />
                            {
                                methods.watch("card_enrollment_category_consumer_link_platform_to_i2c") === "Yes" && (
                                    <>
                                        <div i2c-grid="grid gap-sm" className="mt-24">
                                            <div i2c-grid="12 10@md">
                                                <div className="custom-label">
                                                    Provide the title and description that would be shown on the enrollment screen.
                                                </div>
                                            </div>
                                            <div i2c-grid="12 6@md">
                                                <div className="single-field-wrapper">
                                                    <Controller
                                                        name="card_enrollment_category_consumer_title_for_enrollment_screen"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <I2cInput
                                                                {...field}
                                                                className="single-input-field"
                                                                placeholder="Enter title"
                                                                required
                                                                onI2cInput={(e) => {
                                                                    const value = e.target.value;
                                                                    field.onChange(value);
                                                                    handleValueChanges();
                                                                }}
                                                                size="large"
                                                                name={"card_enrollment_category_consumer_title_for_enrollment_screen"}
                                                            >
                                                                <span slot="label" className="organize-tooltip">
                                                                    <span className="custom-label">
                                                                        {" "}
                                                                        Title
                                                                    </span>
                                                                </span>
                                                            </I2cInput>
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                            <div i2c-grid="12 6@md">
                                                <div className="single-field-wrapper">
                                                    <Controller
                                                        name="card_enrollment_category_consumer_description_for_enrollment_screen"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <I2cInput
                                                                {...field}
                                                                className="single-input-field"
                                                                placeholder="Enter a description..."
                                                                required
                                                                onI2cInput={(e) => {
                                                                    const value = e.target.value;
                                                                    field.onChange(value);
                                                                    handleValueChanges();
                                                                }}
                                                                size="large"
                                                                name={"card_enrollment_category_consumer_description_for_enrollment_screen"}
                                                            >
                                                                <span slot="label" className="organize-tooltip">
                                                                    <span className="custom-label">
                                                                        {" "}
                                                                        Description
                                                                    </span>
                                                                </span>
                                                            </I2cInput>
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            }
                        </div>
                        {
                            type === "credit" && (
                                <div i2c-grid="grid gap-md" className="section-space">
                                    <div i2c-grid="12">
                                        <div className="sub-heading">
                                            <div className="sub-heading">
                                                <span className="productIconFlex">
                                                    <span slot="label" className="organize-tooltip">
                                                        Consumer Credit Card
                                                    </span>
                                                    <AppSelectionIcons
                                                        appSelectionForProgram={appSelectionForProgram}
                                                        mobileLink="https://example.com/mobile-app-a"
                                                        webLink="https://example.com/web-app-a"
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div i2c-grid="12">
                                        <div className="custom-label mb-1-5">
                                            Please select if you want a secured or unsecured credit program.
                                        </div>
                                        <div className="single-field-wrapper">
                                            <Controller
                                                name="card_enrollment_consumer_credit_card"
                                                control={control}
                                                render={({ field }) => (
                                                    <I2cRadioGroup
                                                        onI2cChange={(e) => {
                                                            methods.setValue("card_enrollment_consumer_credit_card", e.target.value);
                                                            methods.trigger();
                                                            handleValueChanges();
                                                        }}
                                                    >
                                                        <div i2c-grid="grid gap-sm">
                                                            {consumer_credit_card_type_data.map((cpi, index) => (
                                                                <I2cListItem
                                                                    key={index}
                                                                    i2c-grid="6@md"
                                                                    variant="receipt"
                                                                    label={cpi.label}
                                                                    sublabel=""
                                                                    value=""
                                                                    checked={methods.watch("card_enrollment_consumer_credit_card") === cpi.value}
                                                                    type="checkbox"
                                                                >
                                                                    <I2cRadio
                                                                        slot="prefix"
                                                                        name="credit_programType"
                                                                        value={cpi.value}
                                                                        filled
                                                                        label=""
                                                                        checked={
                                                                            methods.watch("card_enrollment_consumer_credit_card") === cpi.value
                                                                        }
                                                                    />
                                                                </I2cListItem>
                                                            ))}
                                                        </div>
                                                    </I2cRadioGroup>
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        <ConsumerEnrollmentAndShippmentMethod
                            control={control}
                            handleValueChanges={handleValueChanges}
                            methods={methods}
                            errors={errors}
                            appSelectionForProgram={appSelectionForProgram}
                            isFormDataUpdated={isFormDataUpdated}
                        />

                    </I2cTabPanel>
                    <I2cTabPanel name="Business">
                        <div i2c-grid="grid gap-md" className="section-space">
                            <div i2c-grid="12">
                                <Controller
                                    name="card_enrollment_category_business_link_platform_to_i2c"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cRadioGroup
                                            label="Do you want to opt for this product category?"
                                            {...field}
                                            name="card_enrollment_category_business_link_platform_to_i2c"
                                            onI2cChange={(e) => {
                                                field.onChange(e);
                                                if(e.target.value === "No"){
                                                    methods.setValue("card_enrollment_category_business_title_for_enrollment_screen","")
                                                    methods.setValue("card_enrollment_category_business_description_for_enrollment_screen","")
                                                }
                                                methods.trigger();
                                                handleValueChanges();
                                            }}
                                        >
                                            {["Yes", "No"].map((cECPTD, index) => (
                                                <I2cRadioButton
                                                    key={index}
                                                    checked={
                                                        methods.watch("card_enrollment_category_business_link_platform_to_i2c") === cECPTD
                                                    }
                                                    value={cECPTD}
                                                >
                                                    {cECPTD}
                                                </I2cRadioButton>
                                            ))}
                                        </I2cRadioGroup>
                                    )}
                                />
                                <ErrorMessage
                                    show={
                                        errors.card_enrollment_category_business_link_platform_to_i2c &&
                                            methods.formState.touchedFields.card_enrollment_category_business_link_platform_to_i2c
                                            ? true
                                            : false
                                    }
                                    message={errors.card_enrollment_category_business_link_platform_to_i2c ?? "Invalid input"}
                                />
                            </div>

                            {
                                methods.watch("card_enrollment_category_business_link_platform_to_i2c") === "Yes" && (
                                    <div i2c-grid="12">
                                        <div i2c-grid="grid gap-sm">
                                            <div i2c-grid="12 6@md">
                                                <div className="single-field-wrapper">
                                                    <Controller
                                                        name="card_enrollment_category_business_title_for_enrollment_screen"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <I2cInput
                                                                {...field}
                                                                className="single-input-field"
                                                                placeholder="Enter title"
                                                                required
                                                                onI2cInput={(e) => {
                                                                    const value = e.target.value;
                                                                    field.onChange(value);
                                                                    handleValueChanges();
                                                                }}
                                                                size="large"
                                                                name={"card_enrollment_category_business_title_for_enrollment_screen"}
                                                            >
                                                                <span slot="label" className="organize-tooltip">
                                                                    <span className="custom-label">
                                                                        {" "}
                                                                        Title
                                                                    </span>
                                                                </span>
                                                            </I2cInput>
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                            <div i2c-grid="12 6@md">
                                                <div className="single-field-wrapper">
                                                    <Controller
                                                        name="card_enrollment_category_business_description_for_enrollment_screen"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <I2cInput
                                                                {...field}
                                                                className="single-input-field"
                                                                placeholder="Enter a description..."
                                                                required
                                                                onI2cInput={(e) => {
                                                                    const value = e.target.value;
                                                                    field.onChange(value);
                                                                    handleValueChanges();
                                                                }}
                                                                size="large"
                                                                name={"card_enrollment_category_business_description_for_enrollment_screen"}
                                                            >
                                                                <span slot="label" className="organize-tooltip">
                                                                    <span className="custom-label">
                                                                        {" "}
                                                                        Description
                                                                    </span>
                                                                </span>
                                                            </I2cInput>
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <BusinessDataTables
                            control={control}
                            handleValueChanges={handleValueChanges}
                            methods={methods}
                            errors={errors}
                            appSelectionForProgram={appSelectionForProgram}
                            isFormDataUpdated={isFormDataUpdated}
                        />
                    </I2cTabPanel>
                    <I2cTabPanel name="Corporate">
                        <div i2c-grid="grid gap-md" className="section-space">
                            <div i2c-grid="12">
                                <I2cAlert
                                    open type="plain" variant="neutral"
                                    headerArt="cs-linear-info" layout="layoutAsideLeft"  >
                                    <span slot="label" className="pt-8">Please contact your i2c Inc. Account Manager to provide the i2c Corporate Portal (C-Partner) CSD as well.</span>
                                </I2cAlert>
                            </div>
                            <div i2c-grid="12">
                                <Controller
                                    name="card_enrollment_category_corporate_link_platform_to_i2c"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cRadioGroup
                                            label="Do you want to opt for this product category?"
                                            {...field}
                                            name="card_enrollment_category_corporate_link_platform_to_i2c"
                                            onI2cChange={(e) => {
                                                field.onChange(e);
                                                if(e.target.value === "No"){
                                                    methods.setValue("card_enrollment_category_corporate_title_for_enrollment_screen","")
                                                    methods.setValue("card_enrollment_category_corporate_description_for_enrollment_screen","")
                                                }
                                                methods.trigger();
                                                handleValueChanges();
                                            }}
                                        >
                                            {["Yes", "No"].map((cECPTD, index) => (
                                                <I2cRadioButton
                                                    key={index}
                                                    checked={
                                                        methods.watch("card_enrollment_category_corporate_link_platform_to_i2c") === cECPTD
                                                    }
                                                    value={cECPTD}
                                                >
                                                    {cECPTD}
                                                </I2cRadioButton>
                                            ))}
                                        </I2cRadioGroup>
                                    )}
                                />
                                <ErrorMessage
                                    show={
                                        errors.card_enrollment_category_corporate_link_platform_to_i2c &&
                                            methods.formState.touchedFields.card_enrollment_category_corporate_link_platform_to_i2c
                                            ? true
                                            : false
                                    }
                                    message={errors.card_enrollment_category_corporate_link_platform_to_i2c?.message ?? "Invalid input"}
                                />
                            </div>

                            {
                                methods.watch("card_enrollment_category_corporate_link_platform_to_i2c") === "Yes" && (
                                    <div i2c-grid="12">
                                        <div i2c-grid="grid gap-sm">
                                            <div i2c-grid="12 6@md">
                                                <div className="single-field-wrapper">
                                                    <Controller
                                                        name="card_enrollment_category_corporate_title_for_enrollment_screen"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <I2cInput
                                                                {...field}
                                                                className="single-input-field"
                                                                placeholder="Enter title"
                                                                required
                                                                onI2cInput={(e) => {
                                                                    const value = e.target.value;
                                                                    field.onChange(value);
                                                                    handleValueChanges();
                                                                }}
                                                                size="large"
                                                                name={"card_enrollment_category_corporate_title_for_enrollment_screen"}
                                                            >
                                                                <span slot="label" className="organize-tooltip">
                                                                    <span className="custom-label">
                                                                        {" "}
                                                                        Title
                                                                    </span>
                                                                </span>
                                                            </I2cInput>
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                            <div i2c-grid="12 6@md">
                                                <div className="single-field-wrapper">
                                                    <Controller
                                                        name="card_enrollment_category_corporate_description_for_enrollment_screen"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <I2cInput
                                                                {...field}
                                                                className="single-input-field"
                                                                placeholder="Enter a description..."
                                                                required
                                                                onI2cInput={(e) => {
                                                                    const value = e.target.value;
                                                                    field.onChange(value);
                                                                    handleValueChanges();
                                                                }}
                                                                size="large"
                                                                name={"card_enrollment_category_corporate_description_for_enrollment_screen"}
                                                            >
                                                                <span slot="label" className="organize-tooltip">
                                                                    <span className="custom-label">
                                                                        {" "}
                                                                        Description
                                                                    </span>
                                                                </span>
                                                            </I2cInput>
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <CorporateDataTables
                            control={control}
                            handleValueChanges={handleValueChanges}
                            methods={methods}
                            errors={errors}
                            appSelectionForProgram={appSelectionForProgram}
                            isFormDataUpdated={isFormDataUpdated}
                        />
                    </I2cTabPanel>
                </I2cTabGroup>
            </div>
            <ShippingMethod
                control={control}
                handleValueChanges={handleValueChanges}
                methods={methods}
                errors={errors}
                appSelectionForProgram={appSelectionForProgram}
                isFormDataUpdated={isFormDataUpdated}
            />
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <span className="productIconFlex">
                            <span slot="label" className="organize-tooltip">
                                Agreements
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                </div>
                <div i2c-grid="12">
                    <div className="single-field-wrapper">
                        <Controller
                            name="card_enrollment_agreement_for_customer_acceptance"
                            control={control}
                            render={({ field }) => (
                                <I2cRadioGroup
                                    label="Please select if you want to provide agreements for customer acceptance."
                                    {...field}
                                    name="card_enrollment_agreement_for_customer_acceptance"
                                    onI2cChange={(e) => {
                                        field.onChange(e);
                                        if(e.target.value === "No"){
                                            methods.setValue("card_enrollment_agreement_type_for_common_toggle","")
                                            methods.setValue("card_enrollment_agreement_type","")
                                            methods.setValue("card_enrollment_agreement_type","")
                                            methods.setValue("card_enrollment_agreement_customized_content_file",[])
                                            methods.setValue("card_enrollment_agreement_external_content_url","")
                                        }
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                >
                                    {["Yes", "No"].map((data, index) => (
                                        <I2cRadioButton
                                            key={index}
                                            checked={
                                                methods.watch("card_enrollment_agreement_for_customer_acceptance") === data
                                            }
                                            value={data}
                                        >
                                            {data}
                                        </I2cRadioButton>
                                    ))}
                                </I2cRadioGroup>
                            )}
                        />
                        <ErrorMessage
                            show={
                                errors.card_enrollment_agreement_for_customer_acceptance &&
                                    methods.formState.touchedFields.card_enrollment_agreement_for_customer_acceptance
                                    ? true
                                    : false
                            }
                            message={errors.card_enrollment_agreement_for_customer_acceptance?.message ?? "Invalid input"}
                        />
                    </div>
                </div>
                {
                    methods.watch("card_enrollment_agreement_for_customer_acceptance") === "Yes" && (
                        <>
                            <div i2c-grid="12">
                                <div className="custom-label mb-8">
                                    The customer will indicate their acceptance by enabling a common toggle control. Please select the agreement types that should be linked to this common toggle control.
                                </div>
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_enrollment_agreement_type_for_common_toggle"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cRadioGroup
                                                onI2cChange={(e) => {
                                                    methods.setValue("card_enrollment_agreement_type_for_common_toggle", e.target.value);
                                                    methods.trigger();
                                                    handleValueChanges();
                                                }}
                                            >
                                                <div i2c-grid="grid gap-sm">
                                                    {card_enrollment_agreement_type_for_common_toggle_data.map((cpi, index) => (
                                                        <I2cListItem
                                                            key={index}
                                                            i2c-grid="4@md"
                                                            variant="receipt"
                                                            label={cpi.label}
                                                            sublabel=""
                                                            value=""
                                                            checked={methods.watch("card_enrollment_agreement_type_for_common_toggle") === cpi.value}
                                                            type="checkbox"
                                                        >
                                                            <I2cRadio
                                                                slot="prefix"
                                                                name="credit_programType"
                                                                value={cpi.value}
                                                                filled
                                                                label=""
                                                                checked={
                                                                    methods.watch("card_enrollment_agreement_type_for_common_toggle") === cpi.value
                                                                }
                                                            />
                                                        </I2cListItem>
                                                    ))}
                                                </div>
                                            </I2cRadioGroup>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_enrollment_agreement_type"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cRadioGroup
                                                label="Please select the agreement types."
                                                {...field}
                                                name="card_enrollment_agreement_type"
                                                onI2cChange={(e) => {
                                                    field.onChange(e);
                                                    if(e.target.value === "Use Customized Content"){
                                                        methods.setValue("card_enrollment_agreement_external_content_url","")
                                                    }else{
                                                        methods.setValue("card_enrollment_agreement_customized_content_file",[])
                                                    }
                                                    methods.trigger();
                                                    handleValueChanges();
                                                }}
                                            >
                                                {card_enrollment_agreement_type_data.map((data, index) => (
                                                    <I2cRadioButton
                                                        key={index}
                                                        checked={
                                                            methods.watch("card_enrollment_agreement_type") === data
                                                        }
                                                        value={data}
                                                    >
                                                        {data}
                                                    </I2cRadioButton>
                                                ))}
                                            </I2cRadioGroup>
                                        )}
                                    />
                                    <ErrorMessage
                                        show={
                                            errors.card_enrollment_agreement_type &&
                                                methods.formState.touchedFields.card_enrollment_agreement_type
                                                ? true
                                                : false
                                        }
                                        message={errors.card_enrollment_agreement_type?.message ?? "Invalid input"}
                                    />
                                </div>
                            </div>
                            {
                                methods.watch("card_enrollment_agreement_type") === "Use Customized Content" ? (
                                    <>
                                        <div i2c-grid="12">
                                            <div className="custom-label mb-1-5">
                                                Content File(s)
                                            </div>
                                            <Controller
                                                name="card_enrollment_agreement_customized_content_file"
                                                control={control}
                                                render={({ field }) => (
                                                    <I2cFileUpload
                                                        ref={getFileRef("card_enrollment_agreement_customized_content_file")}
                                                        // max-file-size="0.439453125"
                                                        autoProcessQueue={false}
                                                        no-mobile-controls
                                                        className="customFileUpload"
                                                        setAcceptedFiles=".svg, .ai,.pdf,.eps"
                                                        icon="linear-document-upload"
                                                        label="Click to upload"
                                                        caption="or drag and drop"
                                                        name="card_enrollment_agreement_customized_content_file"
                                                        message="Format must be SVG, AI, PDF or ESP Format."
                                                        onI2cFileRemoved={(e) => {
                                                            if (
                                                              fileJson?.card_enrollment_agreement_customized_content_file?.length
                                                            )
                                                              methods.setValue(
                                                                "card_enrollment_agreement_customized_content_file",
                                                                fileJson?.card_enrollment_agreement_customized_content_file,
                                                              );
                                                            else methods.setValue("card_enrollment_agreement_customized_content_file", "");
                                                            methods.trigger();
                                                            handleValueChanges();
                                                          }}
                                                          onI2cAddedFile={(e) => {
                                                            const fileRef = getFileRef("card_enrollment_agreement_customized_content_file");
                                                            handleFileUpload(
                                                              fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                                              "card_enrollment_agreement_customized_content_file"
                                                            );
                                                          }}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </>
                                ) : <>
                                    <div i2c-grid="12 6@md">
                                        <div className="single-field-wrapper">
                                            <Controller
                                                name="card_enrollment_agreement_external_content_url"
                                                control={control}
                                                render={({ field }) => (
                                                    <I2cInput
                                                        {...field}
                                                        className="single-input-field"
                                                        placeholder="www.i2cinc.com"
                                                        onI2cInput={(e) => {
                                                            const value = e.target.value;
                                                            field.onChange(value);
                                                            handleValueChanges();
                                                        }}
                                                        size="large"
                                                        name={"card_enrollment_agreement_external_content_url"}
                                                        prefix_label="http://"
                                                    >
                                                        <span slot="label" className="organize-tooltip">
                                                            <span className="custom-label">
                                                                {" "}
                                                                External Link
                                                            </span>
                                                        </span>
                                                    </I2cInput>
                                                )}
                                            />
                                        </div>
                                    </div>
                                </>
                            }
                        </>
                    )
                }
            </div>
            {
                type === "prepaid" && (
                    <FundingSourcePrepaid
                        control={control}
                        handleValueChanges={handleValueChanges}
                        methods={methods}
                        errors={errors}
                        appSelectionForProgram={appSelectionForProgram}
                    />
                )
            }
        </>
    );
};

export default ManageInsideI2cPlatform;
